export const ReferralBannerIconSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="102"
    height="196"
    viewBox="0 0 102 196"
    fill="none"
  >
    <path
      opacity="0.2"
      d="M93.7823 174.742L87.8456 183.166L78.7198 177.686L93.7823 174.742Z"
      fill="#9A7AFF"
    />
    <path
      opacity="0.2"
      d="M64.565 168.905L51.2207 171.024L52.0215 175.32L65.3658 173.2L64.565 168.905Z"
      fill="#9A7AFF"
    />
    <g opacity="0.2">
      <path
        d="M120.02 179.249C120.02 179.249 112.946 176.546 105.467 188.18C97.988 199.814 83.741 188.737 83.741 188.737L87.5255 186.523C87.5255 186.523 98.4775 192.816 102.57 185.907C108.44 175.997 114.073 171.822 120.02 179.249Z"
        fill="#BBA7FF"
      />
    </g>
    <g opacity="0.2">
      <path
        d="M131.286 20.7512C131.286 20.7512 126.525 14.9946 113.606 21.9105C100.687 28.8272 94.1627 12.1783 94.1627 12.1783L98.7015 11.9739C98.7015 11.9739 104.926 22.7785 112.291 18.5067C122.854 12.3791 130.089 11.2863 131.286 20.7512Z"
        fill="#BBA7FF"
      />
    </g>
    <path
      opacity="0.2"
      d="M87.6836 65.0518L75.5645 63.083L79.8891 55.7928L88.8079 63.1566L87.6836 65.0518Z"
      fill="#9A7AFF"
    />
    <path
      opacity="0.2"
      d="M92.2661 40.6503C94.8498 40.6503 96.9442 38.7169 96.9442 36.332C96.9442 33.947 94.8498 32.0137 92.2661 32.0137C89.6824 32.0137 87.5879 33.947 87.5879 36.332C87.5879 38.7169 89.6824 40.6503 92.2661 40.6503Z"
      fill="#9A7AFF"
    />
    <path
      opacity="0.2"
      d="M42.9341 32.5557L44.961 38.314H51.5216L46.2144 41.8734L48.2413 47.6318L42.9341 44.0733L37.6269 47.6318L39.6548 41.8734L34.3477 38.314H40.9072L42.9341 32.5557Z"
      fill="#BBA7FF"
    />
    <g opacity="0.7">
      <path
        d="M16.9231 166.624L149.624 156.729C154.639 156.355 158.376 152.3 157.97 147.671L151.716 76.2052C151.311 71.5764 146.917 68.1271 141.903 68.5016L9.20192 78.3965C3.75975 78.8025 -0.295288 83.2034 0.144547 88.2269L6.27345 158.263C6.71252 163.286 11.4809 167.03 16.9231 166.624Z"
        fill="#BBA7FF"
      />
      <g opacity="0.2">
        <path
          d="M155.576 120.252L0.00575256 86.5831L0.959885 97.4808L156.877 135.124L155.576 120.252Z"
          fill="black"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M68.252 74.0128L54.8152 109.108L41.6944 164.797L27.6317 165.845L50.2481 100.793L55.6538 74.9525L68.252 74.0128Z"
          fill="black"
        />
      </g>
      <path
        d="M53.091 106.221C54.0466 109.854 50.5552 110.395 56.3326 111.579C61.5036 112.626 69.3051 115.611 75.2495 114.635C83.0711 113.352 81.9873 107.37 82.0264 102.862C82.2853 99.5023 82.9294 99.1595 78.3106 98.9697C75.5503 98.7116 71.7963 99.3277 68.6674 99.8409C63.0168 101.006 60.5602 101.947 53.1091 105.98L53.091 106.221Z"
        fill="#696088"
      />
      <path
        d="M54.5238 104.455C55.9823 102.652 59.1208 101.332 61.3328 100.337C64.6099 98.8628 68.2239 97.94 71.6832 97.3343C74.8589 96.7788 83.3705 95.4306 82.454 99.8052C81.8295 102.784 76.0386 101.464 74.2946 101.022C70.2825 100.006 64.6168 100.538 60.2719 101.919C59.1239 102.284 57.9314 102.809 56.8437 103.323C56.3617 103.551 54.7333 104.568 54.6104 104.374"
        fill="#514B67"
      />
      <path
        d="M55.2522 103.824C53.6069 104.081 51.9361 104.776 50.2903 105.032C48.6989 109.276 50.9453 117.935 52.0575 122.485C53.8475 129.546 58.0344 137.54 63.9884 143.081C63.6746 138.842 62.0109 134.452 63.3204 130.397C68.1747 131.168 73.2019 133.728 77.7375 135.348C74.8066 129.265 68.5829 123.694 65.3811 117.579C62.4247 111.936 61.289 107.826 55.8044 103.666"
        fill="#696088"
      />
      <path
        d="M44.7653 105.621C44.4346 106.731 42.8854 107.503 41.9676 108.252C39.247 110.476 36.3724 112.56 33.6806 114.806C29.4474 118.339 26.3625 122.938 24.5601 127.768C23.8502 129.672 23.3075 131.636 23.0853 133.664C23.0065 134.382 22.9093 135.809 23.7866 134.628C26.0445 131.591 29.6016 129.386 32.908 127.159C33.567 126.716 34.2766 126.143 35.0955 125.91C34.8292 127.941 36.1534 130.144 37.1698 132.107C38.0138 133.732 39.18 135.24 40.2953 136.771C40.8028 137.467 41.6649 139.205 42.5956 139.54C41.859 138.268 41.8535 136.813 41.818 135.49C41.7618 133.399 41.8553 131.265 42.4774 129.292C43.5414 125.913 46.0079 123.06 47.4739 119.834C49.0981 116.266 50.1279 112.537 49.7382 108.531C49.6203 107.311 49.7069 105.921 49.1481 104.723C48.7349 103.839 48.5036 104.14 47.8107 104.473C47.2746 104.729 46.6456 104.842 46.0836 105.026C45.6997 105.152 45.1805 105.519 44.762 105.498"
        fill="#696088"
      />
      <path
        d="M53.2773 100.17C49.9115 103.77 53.0304 104.243 46.488 105.512C40.6413 106.633 30.8864 109.713 25.612 108.854C18.6716 107.725 23.7254 101.806 26.6809 97.3611C28.6545 94.0522 28.2405 93.7248 32.968 93.4576C35.8897 93.1553 39.2203 93.6976 41.996 94.1496C46.8524 95.1989 48.6747 96.0848 53.4189 99.9333L53.2773 100.17Z"
        fill="#696088"
      />
      <path
        d="M53.5234 104.134C53.2245 101.722 50.9458 99.4226 49.3817 97.73C47.0636 95.2217 44.0582 93.2492 41.0047 91.6757C38.2013 90.2305 30.5968 86.5176 28.7146 91.6943C27.433 95.2196 34.0351 95.219 36.0523 95.1682C40.6913 95.053 45.9869 97.1126 49.4259 99.7903C50.3352 100.498 51.1855 101.398 51.9386 102.258C52.2728 102.64 53.2428 104.208 53.4889 104.02"
        fill="#514B67"
      />
      <path
        d="M46.8486 98.7821C48.4514 100.271 48.4596 103.019 48.5581 104.801C48.663 106.696 47.6343 108.367 47.3109 110.169C47.2593 110.457 47.1677 110.706 47.2356 110.985C47.3754 111.563 47.1025 111.257 47.774 111.48C48.5539 111.74 49.5483 111.766 50.3778 111.955C52.0855 112.341 54.4507 112.87 55.8066 112.007C59.3401 109.761 59.8958 105.912 58.4384 102.188C57.789 100.529 56.9446 99.5223 54.8668 99.285C52.8821 99.0577 50.8326 98.9701 48.8696 98.8559C48.1473 98.8137 47.4545 98.6782 46.8181 98.9271"
        fill="#514B67"
      />
    </g>
  </svg>
);
